import { fetchCapabilities } from 'wms-forecast-client/src/capabilities.js';
import { fetchFeatureInfo, runWithConcurrency } from 'wms-forecast-client/src/wms.js';
import { metaLayer, layerName, styleForVariable } from 'wms-forecast-client/src/layers.js';
import { findGridAxes } from 'wms-forecast-client/src/gridAxes.js';
import { distanceKm } from './map_markers.js';
import { mytephi } from '../index.js'

class Tephi_var {
  constructor(nomvar) {
    this.nomvar = nomvar;
    this.present = false;
    this.p_max = null;
    this.p_min = null;
    this.data = [];
    this.levels = [];
    this.diag = null;
    this.mult = null;
  }
}

class Tephi_prof {
  constructor(model, lat, lon) {
    this.model = model;
    this.lat = lat;
    this.lon = lon;
    this.grid_point_coor = null; // Array [longitude,latitude]
    this.axisU = null; // Array [dLon,dLat], cf. wms-forecast-client/src/gridAxes.js
    this.axisV = null;
    this.dateo_wms_format = null;
    this.datev_wms_format = null;
    this.datev = null;
    this.p0 = null;
    this.knams = 0.5147910000000E+00;
    this.ind_T = 0;
    this.ind_Td = 1;
    this.ind_UU = 2;
    this.ind_WD = 3;
    this.ind_GZ = 4;
    this.tephi_var = new Array(5);
    this.tephi_var[0] = new Tephi_var("TT");
    this.tephi_var[1] = new Tephi_var("ES");
    this.tephi_var[2] = new Tephi_var("WSPD");
    this.tephi_var[3] = new Tephi_var("WD");
    this.tephi_var[4] = new Tephi_var("GZ");
    this.tephi_var[this.ind_T].mult = 1.;
    this.tephi_var[this.ind_Td].mult = 1.;
    this.tephi_var[this.ind_UU].mult = 1. / this.knams;
    this.tephi_var[this.ind_WD].mult = 1.;
    this.tephi_var[this.ind_GZ].mult = 1.;
    if (this.model == "HRDPS") {
      this.resolution = 2.5;
    } else if (this.model == "RDPS" || this.model == "GDPS") {
      this.resolution = 10.;
    } else {
      alert('Internal error in class Tephi_prof, add variable ' + this.model + ' to this.resolution');
      return;
    }
  }
  get_nb_of_layers() {
    var count = 0;
    for (let i = 0; i < this.tephi_var.length; i++) {
      if (this.tephi_var[i].present) {
        count = count + this.tephi_var[i].levels.length
        // Add diag level
        count++
      }
    }
    // Add surface pressure
    count++
    return count;
  }
  is_a_sub_profile(profile) {
    // profile is the candidate to a match
    // "this." is the current user request.
    var debug = false;
    
    if (this.model != profile.model) {
      if (debug) { console.log("From method is_a_sub_profile, not same model"); }
      return false;
    }
    if (this.lat != profile.lat && this.lon != profile.lon) {
      // lat lon may not be the same but actual grid point may be the same.
      if (this.distance_from_grid_point(profile.grid_point_coor[1], profile.grid_point_coor[0])
        > .5 * this.resolution) {
        if (debug) { console.log("From method is_a_sub_profile, not same grid point, distance=" + this.distance_from_grid_point(profile.grid_point_coor[1], profile.grid_point_coor[0])); }
        return false;
      }
    }
    if (this.dateo_wms_format != profile.dateo_wms_format) {
      if (debug) { console.log("From method is_a_sub_profile, not same dateo"); }
      return false;
    }
    if (this.datev_wms_format != profile.datev_wms_format) {
      if(debug){console.log("From method is_a_sub_profile, not same datev");}      
      return false;
    }
    for (let i = 0; i < this.tephi_var.length; i++) {
      if (this.tephi_var[i].present == true) {
        if (profile.tephi_var[i].present == false) {
          if (debug) { console.log("From method is_a_sub_profile, no " + this.tephi_var[i].nomvar); }
          return false;
        }
        if(this.tephi_var[i].p_max == "Surface") {
          if(profile.tephi_var[i].p_max != "Surface") {
            if (debug) { console.log("From method is_a_sub_profile, no match for p_max, candidate is " + profile.tephi_var[i].p_max + " current value is " + this.tephi_var[i].p_max); }
            return false;
          }
        }else{
          if(profile.tephi_var[i].p_max == "Surface") {
            if (debug) { console.log("From method is_a_sub_profile, no match for p_max, candidate is " + profile.tephi_var[i].p_max + " current value is " + this.tephi_var[i].p_max); } 
            return false;
          }
          if (parseInt(this.tephi_var[i].p_max) > parseInt(profile.tephi_var[i].p_max)) {
            if (debug) { console.log("From method is_a_sub_profile, no match for p_max, candidate is " + profile.tephi_var[i].p_max + " current value is " + this.tephi_var[i].p_max); }
            return false;
          }
        }
        if (parseInt(this.tephi_var[i].p_min) < parseInt(profile.tephi_var[i].p_min)) {
          if (debug) { console.log("From method is_a_sub_profile, no match for p_min, candidate is " + profile.tephi_var[i].nomvar + " current value is " + this.tephi_var[i].p_min); }
          return false;
        }
      }
    }
    return true;
  }
  distance_from_grid_point(grid_point_lat, grid_point_lon) {
    var deg2rad = 0.3141592653590E+01 / 180.;
    var lon1 = grid_point_lon * deg2rad;
    var lat1 = grid_point_lat * deg2rad;
    var lon2 = this.lon * deg2rad;
    var lat2 = this.lat * deg2rad;
    return Math.acos(Math.sin(lat1) * Math.sin(lat2) +
      Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1)) * 0.6371220000000E+04
  }
}

class WMS_request {
  constructor(tephi_control, levels, markers) {
    this.controller = null;
    this.tephi_control = tephi_control;
    this.tephi_prof_list = [];
    this.markers = markers;
    this.levels = levels;
    this.model = null;
    this.progress_bar = new Progress_bar(document.getElementById("id_progress"));
    this.dateo = new Date();
    this.datev = new Date();
    this.request_completed = 1;
    this.now = null;
    this.hh_min_delta_fcst = null;
    this.hhh_end = null;
  }

  async get_fcst_dates(lat, lon) {
    this.clear_datev_menu();
    this.model = this.tephi_control.get_model();
    this.tephi_control.id_message.innerHTML = "Obtention de la date d'origine et des heures de pr&eacute;vision pour le " + this.model;

    // Abort any fetch requests in progress then create a fresh controller
    if (this.request_completed == 0) {
      this.controller.abort();
    }
    this.request_completed = 0;
    this.controller = new AbortController();
    const signal = this.controller.signal;

    this.progress_bar.update_progress_bar(0.01);
    this.now = new Date();
    const p0Layer = metaLayer(this.model);
    let caps;
    try {
      caps = await fetchCapabilities(p0Layer, signal);
    } catch(e) {
      if (signal.aborted) return;
      console.error('Erreur GetCapabilities:', e);
      this.request_completed = 1;
      return;
    }
    if (signal.aborted) return;

    this.dateo = caps.dateo;
    this.datef = caps.datef;
    this.hhh_end = (caps.datef - caps.dateo) / (1000 * 60 * 60);
    this.hh_min_delta_fcst = caps.deltaHours;

    this.progress_bar.update_progress_bar(1.);
    this.set_datev_menu();
    this.request_completed = 1;
  }

  get_data(pendingMarker = null) {
    if (!this.model || this.model == "UNDEF") {
      alert("Vous devez choisir un modèle avec le menu en haut à gauche");
      return;
    }

    // Abort any fetch requests in progress then create a fresh controller
    if (this.controller) {
      this.controller.abort();
    }
    this.controller = new AbortController();
    const signal = this.controller.signal;

    var tephi_prof = new Tephi_prof(this.model, this.lat, this.lon);
    tephi_prof.dateo_wms_format = Get_Wms_date_format(this.dateo);
    tephi_prof.datev = this.tephi_control.get_datev_menu_text();
    tephi_prof.datev_wms_format = this.tephi_control.get_datev_menu_value();
    var fetch_data_L = this.set_pressure_info(tephi_prof);
    //try to find a saved profiles with this request
    var tephi_prof_found = this.find_saved_profile(tephi_prof);
    if (tephi_prof_found) {
      mytephi.clear_profile();
      this.tephi_control.id_message.innerHTML = "Donn&eacute;es obtenues de la cache"
      if (pendingMarker) { pendingMarker.clear(); }
      // Ce point de grille a déjà été visité (find_saved_profile ne matche
      // que sur un point proche) : les axes ont déjà été sondés la première
      // fois, pas besoin de refaire de requêtes WMS pour redessiner le
      // maillage en rouge.
      if (tephi_prof_found.axisU) {
        this.markers.promote(
          tephi_prof_found.model,
          tephi_prof_found.grid_point_coor[0], tephi_prof_found.grid_point_coor[1],
          tephi_prof_found.axisU, tephi_prof_found.axisV, tephi_prof_found.resolution
        );
      }
      this.plot_tephi(tephi_prof_found);
      return;
    }
    if (!fetch_data_L) {
      this.tephi_control.id_message.innerHTML = "Aucune donn&eacute;e s&eacute;lectionn&eacute;e!"
      if (pendingMarker) { pendingMarker.clear(); }
      return;
    }
    var nb = tephi_prof.get_nb_of_layers();
    this.tephi_control.id_message.innerHTML = "Il y a " + nb.toString() + " couches &agrave; t&eacute;l&eacute;charger."

    // Met à jour la barre de progression selon le nombre de valeurs déjà reçues.
    const updateProgress = () => {
      var count = 0;
      for (let k = 0; k < tephi_prof.tephi_var.length; k++) {
        if (!tephi_prof.tephi_var[k].present) continue;
        for (let g = 0; g < tephi_prof.tephi_var[k].levels.length; g++) {
          if (tephi_prof.tephi_var[k].data[g] > -998.) {
            count++;
          }
        }
        // Le diag compte une seule fois par variable, pas une fois par niveau
        if (tephi_prof.tephi_var[k].diag > -998.) {
          count++;
        }
      }
      if (tephi_prof.p0 > -998.) {
        count++;
      }
      this.progress_bar.update_progress_bar(count / nb);
    };

    // Construire la liste des couches à télécharger (P0, profil de pression, diag)
    const tasks = [{ type: 'p0' }];
    for (let i = 0; i < tephi_prof.tephi_var.length; i++) {
      if (tephi_prof.tephi_var[i].present) {
        for (let j = 0; j < tephi_prof.tephi_var[i].levels.length; j++) {
          tasks.push({ type: 'pres', i, j });
        }
        tasks.push({ type: 'diag', i });
      }
    }

    // Nombre de requêtes en vol simultanément — au-delà, GeoMet répond 429
    const CONCURRENCY = 10;
    const worker = async (task) => {
      if (task.type === 'p0') {
        try {
          const { value, gridLon, gridLat } = await fetchFeatureInfo({
            layer: metaLayer(this.model),
            lat: this.lat,
            lon: this.lon,
            time: tephi_prof.datev_wms_format,
            refTime: tephi_prof.dateo_wms_format,
            style: styleForVariable('P0')
          }, signal);
          tephi_prof.p0 = value / 100.;
          tephi_prof.grid_point_coor = [gridLon, gridLat];
          if (pendingMarker) { pendingMarker.clear(); }
          // Sonde les axes réels de la grille (3-6 requêtes WMS, cf.
          // wms-forecast-client/src/gridAxes.js) sans bloquer les autres
          // fetch en vol, puis dessine le maillage. Les axes sont mis en
          // cache sur tephi_prof pour qu'un futur hit sur ce même point de
          // grille n'ait pas à re-sonder (cf. branche find_saved_profile).
          findGridAxes({
            layer: metaLayer(this.model),
            style: styleForVariable('P0'),
            time: tephi_prof.datev_wms_format,
            refTime: tephi_prof.dateo_wms_format,
            lon0: gridLon,
            lat0: gridLat
          }, signal).then(({ axisU, axisV }) => {
            if (signal.aborted) return;
            tephi_prof.axisU = axisU;
            tephi_prof.axisV = axisV;
            this.markers.promote(this.model, gridLon, gridLat, axisU, axisV, tephi_prof.resolution);
          }).catch((error) => {
            if (signal.aborted) return;
            console.error('Erreur lors du calcul du maillage de grille:', error);
          });
        } catch (error) {
          tephi_prof.p0 = -999;
          if (pendingMarker) { pendingMarker.clear(); }
          console.error('Error:', error);
        }
      } else if (task.type === 'pres') {
        const { i, j } = task;
        const isGZ_pres = tephi_prof.tephi_var[i].nomvar === 'GZ';
        try {
          const { value } = await fetchFeatureInfo({
            layer: layerName(this.model, tephi_prof.tephi_var[i].nomvar, tephi_prof.tephi_var[i].levels[j]),
            lat: this.lat,
            lon: this.lon,
            time: isGZ_pres ? tephi_prof.dateo_wms_format : tephi_prof.datev_wms_format,
            refTime: tephi_prof.dateo_wms_format,
            style: styleForVariable(tephi_prof.tephi_var[i].nomvar, this.model)
          }, signal);
          tephi_prof.tephi_var[i].data[j] = parseFloat(value * tephi_prof.tephi_var[i].mult);
        } catch (error) {
          tephi_prof.tephi_var[i].data[j] = -999;
          console.error('Error:', error);
        }
      } else {
        const { i } = task;
        const isGZ_diag = tephi_prof.tephi_var[i].nomvar === 'GZ';
        try {
          const { value } = await fetchFeatureInfo({
            layer: layerName(this.model, tephi_prof.tephi_var[i].nomvar, 'diag'),
            lat: this.lat,
            lon: this.lon,
            time: isGZ_diag ? tephi_prof.dateo_wms_format : tephi_prof.datev_wms_format,
            refTime: tephi_prof.dateo_wms_format,
            style: styleForVariable(tephi_prof.tephi_var[i].nomvar, this.model)
          }, signal);
          tephi_prof.tephi_var[i].diag = parseFloat(value * tephi_prof.tephi_var[i].mult);
        } catch (error) {
          tephi_prof.tephi_var[i].diag = -999;
          console.error('Error:', error);
        }
      }
      updateProgress();
    };

    runWithConcurrency(tasks, worker, CONCURRENCY)
      .then(() => {
        // La requête a été annulée car l'utilisateur a recliqué — ne pas tracer
        if (signal.aborted) return;
        var OK = 1;
        for (let i = 0; i < tephi_prof.tephi_var.length; i++) {
          for (let j = 0; j < tephi_prof.tephi_var[i].levels.length; j++) {
            if (tephi_prof.tephi_var[i].data[j] < -998.) {
              OK = 0;
            }
          }
        }
        if (OK == 0) {
          this.tephi_control.id_message.innerHTML = "Probl&egrave;me avec le t&eacute;l&eacute;chargement de certaines donn&eacute;es"
          this.progress_bar.reset_progress_bar(0.);
          return
        }
        this.progress_bar.update_progress_bar(1.);
        this.progress_bar.reset_progress_bar(0.);
        this.compute_td(tephi_prof);
        this.plot_tephi(tephi_prof);
        // Ne mettre en cache que les profils complets — un profil annulé/incomplet
        // ne doit jamais pouvoir être retrouvé par find_saved_profile()
        this.tephi_prof_list.push(tephi_prof);
        this.tephi_control.id_message.innerHTML = nb.toString() + " couches t&eacute;l&eacute;charg&eacute;es avec succ&egrave;s"
      }).catch((error) => {
        this.tephi_control.id_message.innerHTML = "Requ&ecirc;te termin&eacute;e avec erreurs :-("
        console.error('Error:', error);
      });
  }

  compute_td(tephi_prof) {
    for (let i = 0; i < tephi_prof.tephi_var[tephi_prof.ind_Td].data.length; i++) {
      var found = false;
      var pres = tephi_prof.tephi_var[tephi_prof.ind_Td].levels[i];
      for (let j = 0; j < tephi_prof.tephi_var[tephi_prof.ind_T].data.length; j++) {
        if (tephi_prof.tephi_var[tephi_prof.ind_T].levels[j] == pres) {
          found = true;
          tephi_prof.tephi_var[tephi_prof.ind_Td].data[i] =
            tephi_prof.tephi_var[tephi_prof.ind_T].data[j] -
            tephi_prof.tephi_var[tephi_prof.ind_Td].data[i]
        }
      }
      if (!found) {
        alert("Tous les niveaux de Td doivent être inclus dans ceux de la tempérture");
        return;
      }
    }
    tephi_prof.tephi_var[tephi_prof.ind_Td].diag =
      tephi_prof.tephi_var[tephi_prof.ind_T].diag -
      tephi_prof.tephi_var[tephi_prof.ind_Td].diag
  }

  plot_tephi(tephi_prof) {
    mytephi.clear_profile();
    if (tephi_prof.tephi_var[tephi_prof.ind_T].present) {
      mytephi.plot_profile_wms(tephi_prof.p0,
        tephi_prof.tephi_var[tephi_prof.ind_T].diag,
        tephi_prof.tephi_var[tephi_prof.ind_T].data,
        tephi_prof.tephi_var[tephi_prof.ind_T].levels,'température','red')
    }
    if (tephi_prof.tephi_var[tephi_prof.ind_Td].present) {
      mytephi.plot_profile_wms(tephi_prof.p0,
        tephi_prof.tephi_var[tephi_prof.ind_Td].diag,
        tephi_prof.tephi_var[tephi_prof.ind_Td].data,
        tephi_prof.tephi_var[tephi_prof.ind_Td].levels,'point de rosée','blue')
    }
    if (tephi_prof.tephi_var[tephi_prof.ind_UU].present) {
      // Find maximum index i of tt points over tephi wind data
      // to plot wind profile to the right of it.
      var found = false;
      var count = 0;
      if (tephi_prof.tephi_var[tephi_prof.ind_T].present) {
        for (var i = 0; i < tephi_prof.tephi_var[tephi_prof.ind_UU].data.length; i++) {
          for (var j = 0; j < tephi_prof.tephi_var[tephi_prof.ind_T].data.length; j++) {
            if (tephi_prof.tephi_var[tephi_prof.ind_T].levels[j] ==
              tephi_prof.tephi_var[tephi_prof.ind_UU].levels[i]) {
              found = true;
              ij = mytephi.temp_pres_to_i_j(tephi_prof.tephi_var[tephi_prof.ind_T].data[j],
                tephi_prof.tephi_var[tephi_prof.ind_T].levels[j])
              break;
            }
          }
          if (found) {
            if (count == 0) {
              var i_max = ij[0];
              var T_imax = tephi_prof.tephi_var[tephi_prof.ind_T].data[j];
              var p_imax = tephi_prof.tephi_var[tephi_prof.ind_T].levels[j];
            } else {
              if (ij[0] > i_max) {
                var i_max = ij[0];
                var T_imax = tephi_prof.tephi_var[tephi_prof.ind_T].data[j];
                var p_imax = tephi_prof.tephi_var[tephi_prof.ind_T].levels[j];
              }
            }
            count++;
          }
        }
        if (!found) {
          var T_imax = 0;
          var p_imax = 1000.;
          var ij = mytephi.temp_pres_to_i_j(T_imax, p_imax);
          i_max = ij[0];
        }
      } else {
        var T_imax = 0;
        var p_imax = 1000.;
        var ij = mytephi.temp_pres_to_i_j(T_imax, p_imax);
        i_max = ij[0];
      }
      mytephi.plot_winds_wms(tephi_prof.p0,
        tephi_prof.tephi_var[tephi_prof.ind_UU].diag,
        tephi_prof.tephi_var[tephi_prof.ind_UU].data,
        tephi_prof.tephi_var[tephi_prof.ind_WD].diag,
        tephi_prof.tephi_var[tephi_prof.ind_WD].data,
        tephi_prof.tephi_var[tephi_prof.ind_UU].levels, i_max, T_imax, p_imax);
    }
    if (tephi_prof.tephi_var[tephi_prof.ind_GZ].present) {
      // Find maximum index i of tt points over tephi wind data
      // to plot GZ profile to the right of it, add space if wind is present
      var found = false;
      var count = 0;
      if (tephi_prof.tephi_var[tephi_prof.ind_T].present) {
        for (var i = 0; i < tephi_prof.tephi_var[tephi_prof.ind_GZ].data.length; i++) {
          for (var j = 0; j < tephi_prof.tephi_var[tephi_prof.ind_T].data.length; j++) {
            if (tephi_prof.tephi_var[tephi_prof.ind_T].levels[j] ==
              tephi_prof.tephi_var[tephi_prof.ind_GZ].levels[i]) {
              found = true;
              ij = mytephi.temp_pres_to_i_j(tephi_prof.tephi_var[tephi_prof.ind_T].data[j],
                tephi_prof.tephi_var[tephi_prof.ind_T].levels[j])
              break;
            }
          }
          if (found) {
            if (count == 0) {
              var i_max = ij[0];
              var T_imax = tephi_prof.tephi_var[tephi_prof.ind_T].data[j];
              var p_imax = tephi_prof.tephi_var[tephi_prof.ind_T].levels[j];
            } else {
              if (ij[0] > i_max) {
                var i_max = ij[0];
                var T_imax = tephi_prof.tephi_var[tephi_prof.ind_T].data[j];
                var p_imax = tephi_prof.tephi_var[tephi_prof.ind_T].levels[j];
              }
            }
            count++;
          }
        }
        if (!found) {
          var T_imax = 0;
          var p_imax = 1000.;
          var ij = mytephi.temp_pres_to_i_j(T_imax, p_imax);
          i_max = ij[0];
        }
      } else {
        var T_imax = 0;
        var p_imax = 1000.;
        var ij = mytephi.temp_pres_to_i_j(T_imax, p_imax);
        i_max = ij[0];
      }
      if (document.getElementById('id_height_no').checked == false){
        mytephi.plot_GZ_profile_wms(tephi_prof.p0,
          tephi_prof.tephi_var[tephi_prof.ind_GZ].diag,
          tephi_prof.tephi_var[tephi_prof.ind_GZ].data,
          tephi_prof.tephi_var[tephi_prof.ind_GZ].levels, T_imax, p_imax);
        }
    }
    this.tephi_control.id_product_displayed.innerHTML = "Affich&eacute; : mod&egrave;le " + this.model + ",\n valide : " + tephi_prof.datev;
  }

  clear_datev_menu() {
    const menu = this.tephi_control.id_datev_menu;
    var ni = menu.options.length - 1;
    for (let i = ni; i >= 0; i--) {
      menu.remove(i);
    }
  }

  set_datev_menu() {
    const menu = this.tephi_control.id_datev_menu;
    let i = 0;
    let ind = 0;
    var datev = new Date(this.dateo.getTime());
    const options = { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', timeZoneName: 'short' };
    while (i <= this.hhh_end) {
      if (i == 1000) {
        console.log("Internale error, runaway loop in set_datev_menu")
        return
      }
      if (datev <= this.now) { ind = i }
      let option = document.createElement("option");
      option.setAttribute('value', Get_Wms_date_format(datev));

      option.appendChild(document.createTextNode('t+' + String(i) + "h : " + datev.toLocaleDateString('fr-fr', options)));
      menu.appendChild(option);
      i = i + this.hh_min_delta_fcst;
      datev.setHours(datev.getHours() + this.hh_min_delta_fcst);
    }
    this.progress_bar.reset_progress_bar(0.);
    menu.selectedIndex = ind;
    this.tephi_control.id_message.innerHTML = "Choisir les variables (cliquer sur le hamburger) et une date de validit&eacute;, et cliquer le point d&eacute;sir&eacute; sur la carte";
  }

  set_pressure_info(tephi_prof) {
    var fetch_data_L = false;
    var p_min = 2000;
    var p_max = -1.;
    if (this.tephi_control.id_temp.checked) {
      fetch_data_L = true;
      tephi_prof.tephi_var[tephi_prof.ind_T].present = true;
      tephi_prof.tephi_var[tephi_prof.ind_T].p_max = this.get_levels(this.tephi_control.id_T_max_level);
      tephi_prof.tephi_var[tephi_prof.ind_T].p_min = this.get_levels(this.tephi_control.id_T_min_level);
      [p_min, p_max] = this.get_pmin_pmax(tephi_prof.tephi_var[tephi_prof.ind_T], p_min, p_max);
      this.get_pressure_list(tephi_prof.tephi_var[tephi_prof.ind_T])
      //alert(tephi_prof.tephi_var[tephi_prof.ind_T].levels)
    }
    if (this.tephi_control.id_td.checked) {
      fetch_data_L = true;
      tephi_prof.tephi_var[tephi_prof.ind_Td].present = true;
      tephi_prof.tephi_var[tephi_prof.ind_Td].p_max = this.get_levels(this.tephi_control.id_Td_max_level);
      tephi_prof.tephi_var[tephi_prof.ind_Td].p_min = this.get_levels(this.tephi_control.id_Td_min_level);
      this.get_pressure_list(tephi_prof.tephi_var[tephi_prof.ind_Td]);
      //alert(tephi_prof.tephi_var[tephi_prof.ind_Td].levels)
    }
    if (this.tephi_control.id_wind.checked) {
      fetch_data_L = true;
      tephi_prof.tephi_var[tephi_prof.ind_UU].present = true;
      tephi_prof.tephi_var[tephi_prof.ind_UU].p_max = this.get_levels(this.tephi_control.id_V_max_level);
      tephi_prof.tephi_var[tephi_prof.ind_UU].p_min = this.get_levels(this.tephi_control.id_V_min_level);
      [p_min, p_max] = this.get_pmin_pmax(tephi_prof.tephi_var[tephi_prof.ind_UU], p_min, p_max);
      this.get_pressure_list(tephi_prof.tephi_var[tephi_prof.ind_UU]);
      //alert(tephi_prof.tephi_var[tephi_prof.ind_UU].levels)
      tephi_prof.tephi_var[tephi_prof.ind_WD].present = true;
      tephi_prof.tephi_var[tephi_prof.ind_WD].p_max = this.get_levels(this.tephi_control.id_V_max_level);
      tephi_prof.tephi_var[tephi_prof.ind_WD].p_min = this.get_levels(this.tephi_control.id_V_min_level);
      this.get_pressure_list(tephi_prof.tephi_var[tephi_prof.ind_WD]);
      //alert(tephi_prof.tephi_var[tephi_prof.ind_WD].levels)
    }
    if (this.tephi_control.id_height_agl.checked || this.tephi_control.id_height_asl.checked) {
      fetch_data_L = true;
      tephi_prof.tephi_var[tephi_prof.ind_GZ].present = true;
      tephi_prof.tephi_var[tephi_prof.ind_GZ].p_max = p_max;
      tephi_prof.tephi_var[tephi_prof.ind_GZ].p_min = p_min;
      this.get_pressure_list(tephi_prof.tephi_var[tephi_prof.ind_GZ]);
      //alert(tephi_prof.tephi_var[tephi_prof.ind_GZ].levels);
    }
    return fetch_data_L;

  }

  get_pmin_pmax(tephi_var, pmin, pmax) {
    if (tephi_var.p_min == "Surface") {
      pmin = 2000;
    } else {
      if (parseInt(tephi_var.p_min) < pmin) {
        pmin = parseInt(tephi_var.p_min);
      }
    }
    if (tephi_var.p_max == "Surface") {
      pmax = 2000;
    } else {
      if (parseInt(tephi_var.p_max) > pmax) {
        pmax = parseInt(tephi_var.p_max);
      };
    }
    return [pmin, pmax];
  }
  get_pressure_list(tephi_var) {
    var list = [];
    if (tephi_var.p_max == "Surface") {
      var p_max_i = 2000;
    } else {
      var p_max_i = parseInt(tephi_var.p_max);
    }
    if (tephi_var.p_min == "Surface") {
      list.push(this.levels.length - 1);
      tephi_var.level = [...list];
      return;
    }
    var p_min_i = parseInt(tephi_var.p_min);
    for (let i = 0; i < this.levels.length; i++) {
      if (this.levels[i] >= p_min_i && this.levels[i] <= p_max_i) {
        list.push(this.levels[i]);
      }
    }
    tephi_var.levels = [...list];
    for (let i = 0; i < tephi_var.levels.length; i++) {
      tephi_var.data.push(-999);
    }
    tephi_var.diag = -999;
  }

  get_levels(id_menu) {
    return id_menu.options[id_menu.selectedIndex].value;
  }

  find_saved_profile(tephi_prof) {
    var found = null;
    for (var i = 0; i < this.tephi_prof_list.length; i++) {
      found = tephi_prof.is_a_sub_profile(this.tephi_prof_list[i]);
      if (found) {
        return this.tephi_prof_list[i];
      }
    }
  }

  // Vide le cache et les marqueurs gris, tous modèles confondus, en gardant
  // uniquement le point courant (celui affiché en rouge sur la carte, s'il y
  // en a un).
  clear_past() {
    var cur = this.markers.current;
    if (cur) {
      this.tephi_prof_list = this.tephi_prof_list.filter(p =>
        p.model === cur.model && p.grid_point_coor &&
        distanceKm(p.grid_point_coor[1], p.grid_point_coor[0], cur.lat, cur.lon) <= 0.5 * p.resolution
      );
    } else {
      this.tephi_prof_list = [];
    }
    this.markers.clearPast();
  }
}

function Get_First_Date(date) {
  var res = new Date();
  res.setFullYear(date.getFullYear());
  res.setDate(date.getDate());
  res.setHours(date.getHours());
  res.setMinutes(0);
  res.setSeconds(0);
  res.setMilliseconds(0);
  return res;
}
function Get_Wms_date_format(date, hour_only = false) {
  var yyyy = String(date.getUTCFullYear())
  var mm = String(date.getUTCMonth() + 1).padStart(2, '0'); //January is 0!
  var dd = String(date.getUTCDate()).padStart(2, '0');
  var hh = String(date.getUTCHours()).padStart(2, '0');
  if (hour_only) {
    return hh;
  } else {
    return yyyy + '-' + mm + '-' + dd + 'T' + hh + ':00:00Z';
  }
}

function Get_graph_date_format(date) {
  var yyyy = String(date.getFullYear())
  var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
  var dd = String(date.getDate()).padStart(2, '0');
  var hh = String(date.getHours()).padStart(2, '0');
  return yyyy + '-' + mm + '-' + dd + ' ' + hh + ':00:00';
}

class Progress_bar {

  constructor(canvas) {
    this.canvas = canvas;
    // Résolution du buffer de dessin = taille CSS réelle, pour un rendu net
    // (sinon le canvas garde sa résolution par défaut 300x150 et le navigateur
    // l'étire/floute pour remplir la boîte CSS).
    this.canvas.width = canvas.clientWidth || 300;
    this.canvas.height = canvas.clientHeight || 24;
  }

  update_progress_bar(percent) {
    var ctx = this.canvas.getContext("2d");
    var w = this.canvas.width;
    var h = this.canvas.height;
    ctx.clearRect(0, 0, w, h);
    // Rien à afficher au repos — espace blanc, pas de contour ni de %
    if (percent < .0001) {
      return;
    }
    ctx.fillStyle = "#EEE";
    ctx.fillRect(0, 0, w, h);
    ctx.fillStyle = "#F00";
    ctx.fillRect(0, 0, percent * w, h);
    ctx.strokeStyle = "#888";
    ctx.strokeRect(0.5, 0.5, w - 1, h - 1);
    ctx.fillStyle = "#000";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.font = Math.floor(h * 0.65) + "px sans-serif";
    ctx.fillText(Math.round(percent * 100) + " %", w / 2, h / 2);
  }

  reset_progress_bar() {
    this.update_progress_bar(0);
    this.precent = 0.
  }

}



export { WMS_request }
